import React from 'react'
import { NavLink, Outlet } from 'react-router-dom'
import { Users, Mic, Megaphone } from 'lucide-react'
import { cn } from '../../lib/utils'

const AdminLayout: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Admin Navigation */}
      <div className="border-b border-secondary-200">
        <nav className="flex space-x-8">
          <NavLink
            to="/admin/users"
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors',
                isActive
                  ? 'border-brand-600 text-brand-600'
                  : 'border-transparent text-foreground/60 hover:text-foreground hover:border-secondary-300'
              )
            }
          >
            <Users className="h-4 w-4" />
            Users
          </NavLink>
          
          <NavLink
            to="/admin/podcasts"
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors',
                isActive
                  ? 'border-brand-600 text-brand-600'
                  : 'border-transparent text-foreground/60 hover:text-foreground hover:border-secondary-300'
              )
            }
          >
            <Mic className="h-4 w-4" />
            Podcasts
          </NavLink>
          <NavLink
            to="/admin/email"
            className={({ isActive }) =>
              cn(
                'flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors',
                isActive
                  ? 'border-brand-600 text-brand-600'
                  : 'border-transparent text-foreground/60 hover:text-foreground hover:border-secondary-300'
              )
            }
          >
            <Megaphone className="h-4 w-4" />
            Email marketing
          </NavLink>
        </nav>
      </div>

      {/* Content */}
      <Outlet />
    </div>
  )
}

export default AdminLayout